<template>
  <van-tabbar class="main-tabs" v-model="active" active-color="#667eea" inactive-color="#999999">
    <van-tabbar-item name="Home" @click="handleGo('Home')">
      <span class="title">{{ $t('tabbar.home') }}</span>
      <template #icon="props">
        <img :src="props.active ? Home.active : Home.inactive" />
      </template>
    </van-tabbar-item>
    <van-tabbar-item name="Query" @click="handleGo('Query')">
      <span class="title">{{ $t('tabbar.query') }}</span>
      <template #icon="props">
        <img :src="props.active ? Category.active : Category.inactive" />
      </template>
    </van-tabbar-item>
    <van-tabbar-item name="Order" @click="handleGo('Order')">
      <span class="title">{{ $t('tabbar.info') }}</span>
      <template #icon="props">
        <img :src="props.active ? RecommendBook.active : RecommendBook.inactive" />
      </template>
    </van-tabbar-item>
    <van-tabbar-item name="My" @click="handleGo('My')">
      <span class="title">{{ $t('tabbar.my') }}</span>
      <template #icon="props">
        <img :src="props.active ? My.active : My.inactive" />
      </template>
    </van-tabbar-item>
  </van-tabbar>
</template>
<script>
export default {
  name: 'Footer',
  data() {
    return {
      active: 'Home',
      Home: {
        active: require('@/assets/images/home_active.png'),
        inactive: require('@/assets/images/home.png'),
      },
      Category: {
        active: require('@/assets/images/category_active.png'),
        inactive: require('@/assets/images/category.png'),
      },
      RecommendBook: {
        active: require('@/assets/images/book_active.png'),
        inactive: require('@/assets/images/book.png'),
      },
      My: {
        active: require('@/assets/images/my_active.png'),
        inactive: require('@/assets/images/my.png'),
      },
    };
  },
  created() {},
  mounted() {
    this.active = this.$route.name;
  },
  methods: {
    handleGo(route) {
      if (route !== this.$route.name) this.$router.push({ name: route });
    },
  },
  //监听路由变化
  watch: {
    // 根据路由判断选中哪个
    '$route.name': function (routeName) {
      this.active = routeName || 'Home';
    },
  },
};
</script>
<style lang="scss">
.main-tabs {
  .van-tabbar-item {
    padding-top: 15px;
    padding-bottom: 3px;
    .van-tabbar-item__icon {
      height: 36px;
    }
    .van-tabbar-item__text {
      height: 33px;
      line-height: 33px;
      font-size: 24px;
      font-weight: 400;
    }
    .van-info {
      width: 36px;
      height: 36px;
      line-height: 36px;
      background: #ff5252;
      border-radius: 50%;
      font-size: 24px;
      color: #ffffff;
      transform: scale(0.667);
      top: -18px;
      right: -16px;
    }
  }
}
</style>
<style lang="scss" scoped>
.van-tabbar {
  height: 98px;
  background: #fff;
  box-shadow: 0px -3px 10px rgba(0, 0, 0, 0.04);
  img {
    height: 40px;
    width: 40px;
    margin-bottom: 11px;
  }
  span {
    font-size: 24px;
    font-weight: 400;
  }
}
</style>
